import React from 'react';
import { AccountData, PassOut } from '../../../../api';
import { useAuth } from '../../../../session/InternalAuthProvider';
import { getPassOrderPage } from '../../../../utils/AccountUtils';
import { PassDetailPanels } from '../../PassDetailTypes';
import { supportsSchedule } from '../../utils';
import { SchedulablePassSchedulePanel } from './SchedulablePassSchedulePanel';

type Props = {
  pass: PassOut;
  expandedPanel: PassDetailPanels | undefined;
  onPanelChange: (panel: PassDetailPanels) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
  onChangeScheduleClick?: () => void;
  onReleaseScheduleClick?: () => void;
};

export const SchedulePanel = ({
  pass,
  expandedPanel,
  onPanelChange,
  onChangeScheduleClick,
  onReleaseScheduleClick,
}: Props) => {
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const passOrderPage = getPassOrderPage(account, pass.order_page_id);
  if (!supportsSchedule(passOrderPage?.pass_type)) return null;
  return (
    <SchedulablePassSchedulePanel
      pass={pass}
      passOrderPage={passOrderPage}
      expandedPanel={expandedPanel}
      onPanelChange={onPanelChange}
      onChangeScheduleClick={onChangeScheduleClick}
      onReleaseScheduleClick={onReleaseScheduleClick}
    />
  );
};
